// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3764":"594dc382","4443":"98400aeb","7370":"1ef70393"}[chunkId] + ".chunk.css";
};